import { makeVar } from '@apollo/client';

export const currentSailingVar = makeVar(null);
export const priceBookingVar = makeVar(null);
export const currentBookingVar = makeVar(null);
